import { Form, Input } from "antd";

export default function EditableCellCoefficient({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}){
  const inputNode = (
    <Input
      type="number"
      placeholder="Nhập hệ số"
      min={0}
      step={0.1}
      style={{ width: "100%" }}
    />
  );

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Vui lòng nhập hệ số!`, // Đổi thành text cố định
            },
            {
              pattern: /^[0-9]*\.?[0-9]+$/,
              message: "Vui lòng nhập số hợp lệ!",
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};